import { isMobile, getOSCode } from './deviceUtil';
import openWithApp from './openWithApp';

export default function openWithAppTalk(device, customUrl, appScheme = process.env.REACT_APP_PF_CUSTOM_SCHEME, useIntent = false) {
  const packageName = process.env.REACT_APP_ANDROID_PACKAGE_NAME || 'com.kakao.talk';
  const appStoreUrl = 'https://itunes.apple.com/kr/app/kakaotog-kakaotalk/id362057947';
  const deviceOs = getOSCode(device);
  if (!isMobile(device)) {
    alert('카카오톡 모바일앱에서 가능합니다.');
    return;
  }
  openWithApp(deviceOs, appScheme, customUrl, packageName, appStoreUrl, useIntent);
}



// WEBPACK FOOTER //
// ./src/utils/openWithAppTalk.js